import { render } from "./bymyVideos.vue?vue&type=template&id=4c3e383a&scoped=true"
import script from "./bymyVideos.vue?vue&type=script&lang=js"
export * from "./bymyVideos.vue?vue&type=script&lang=js"

import "./bymyVideos.vue?vue&type=style&index=0&id=4c3e383a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3e383a"]])

export default __exports__